import { BaseAgent } from 'agents';

const PaymentAgent = {
    paypal: (data: any) =>
        BaseAgent.post('/payment/subscribe/paypal/process', data),
    paypalConfirm: (response: any) =>
        BaseAgent.post('/payment/subscribe', { paypal_response: response }),
    card: (data: any) => BaseAgent.post('/payment/subscribe', data),
    updateCard: ({
        ptoken,
        email,
        ZIPCode,
    }: {
        ptoken: string;
        email: string;
        ZIPCode: string;
    }) =>
        BaseAgent.post('/payment/web/creditcard/update', {
            ptoken,
            email,
            zip_code: ZIPCode,
        }),
    upgrade: (plan: any, data: any = {}) =>
        BaseAgent.post('/payment/web/upgrade', { plan, ...data }),
    resubscribe: (plan: any, data: any = {}) =>
        BaseAgent.post('/payment/resubscribe', { plan, ...data }),
    purchaseGift: (data: any) => BaseAgent.post('/payment/gift/purchase', data),
};

export default PaymentAgent;
